/** @format */

import SwitchButton from '../../../Shared/Components/SwitchButton';

const Checkbox = ({ field, onChangeValue, teamForm }) => {
	console.log(field);
	return (
		<div className='form-group d-flex flex-column'>
			<label>{field.label}</label>
			<SwitchButton
				checked={field?.value == '0' ? false : true}
				onChange={(val) => {
					onChangeValue(
						field?.name,
						field.value == '0' ? true : false,
						teamForm,
					);
				}}
			/>
		</div>
	);
};

export default Checkbox;
